import SectionHeader from "../../components/ui/labels/SectionHeader";
import { useState, useContext } from "react";
import DateSelect from "../../components/ui/dropdowns/DateSelect";
import Form from "../../components/ui/input/Form";
import DataLabel from "../../components/ui/labels/DataLabel";
import Button from "../../components/ui/buttons/Button";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import axios from "axios";
import AuthContext from "../../components/context/AuthContext";
import InfoPrompt from "../../components/ui/prompts/InfoPrompt";
// Do not remove import, required.
// eslint-disable-next-line
import { useAddDateDays } from "../../hooks/useAddDateDays";
import useSplicerAuditReport from "./useSplicerAuditReport";
import TablePagination from "../../components/ui/table/TablePagination";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";

const SplicerAuditReport = () => {
  const authCtx = useContext(AuthContext);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [status, setStatus] = useState("");
  const { columns } = useSplicerAuditReport();

  const dateSelectHandler = (dates) => {
    const [start, end] = dates;
    if (start) {
      start.setHours(0, 0, 0, 0);
    }
    if (end) {
      end.setHours(0, 0, 0, 0);
    }
    setStartDate(start);
    setEndDate(end);
  };

  let dateText = () => {
    let text = "";
    try {
      let dateText = startDate.toLocaleDateString();
      text += dateText;
    } catch {}
    try {
      let dateText = endDate.toLocaleDateString();
      text += ` - ${dateText}`;
    } catch {}
    return text;
  };

  const fetchReport = (event) => {
    event.preventDefault();
    setLoading(true);
    let url = `${process.env.REACT_APP_API_URL}/audit/splicerReport`;
    let formData = {
      startDate: startDate,
      endDate: endDate.useAddDateDays(1),
    };
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    axios
      .post(url, formData, authObj)
      .then((response) => {
        if (response && response.data && response.status === 200) {
          setReportData(response.data);
        } else {
          setStatus("Failed to construct report, invalid response received.");
          setReportData(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        setStatus(
          `Error while constructing report: ${
            error?.data ? error.data : error?.message
          }`
        );
        setReportData(null);
        setLoading(false);
      });
  };

  return (
    <>
      <SectionHeader text="Splicer Audit Report" />
      <DevModeLabel />
      <Form>
        <DataLabel title="Date Range" text={dateText()} />
        <DateSelect
          startDate={startDate}
          endDate={endDate}
          onChangeHandler={dateSelectHandler}
        />
        <Button
          text="Fetch Report"
          onClick={fetchReport}
          disabled={!startDate || !endDate}
        />
      </Form>
      {reportData && (
        <TablePagination
          columns={columns}
          data={reportData}
          rowClickHandler={() => {}}
        />
      )}

      <FullScreenActivityIndicator
        loading={loading}
        text="Fetching Audit Report..."
      />
      <InfoPrompt text={status} statusCleared={() => setStatus("")} />
    </>
  );
};

export default SplicerAuditReport;
